import { GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl as getSignedUrlFromS3 } from "@aws-sdk/s3-request-presigner";

import gAxios from "../../hooks/useAxios";
import { GET_ALBUM, GET_IMAGES } from "../../utils/const";
const { S3Client } = require("@aws-sdk/client-s3");

export const bucketNamePrefix = window.location.href.includes(
  "mavvidyashram.com",
)
  ? "mavschool"
  : "mavinternationalbucket";
// Configure the S3 client
const s3Client = new S3Client({
  region: process.env.REACT_APP_REGION,
  credentials: {
    accessKeyId: "",
    secretAccessKey: "",
  },
});

export const getGallery = async (year: string | number) => {
  try {
    let params = {
      year: year,
    };
    const response = await gAxios.get(GET_ALBUM, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error", error);
  }
};

export const getImages = async (year: string, album: string) => {
  try {
    let params = {
      year: year,
      album: album,
    };
    const response = await gAxios.get(GET_IMAGES, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error", error);
  }
};

export const listFoldersInS3 = async (prefixString?: string) => {
  // Construct the URL to query S3 using list-type=2 and delimiter to group objects by folder.
  const url = `https://${bucketNamePrefix}.s3.amazonaws.com/?list-type=2&prefix=${prefixString ? `${prefixString}/` : ""}&delimiter=/`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to fetch folder list");
    }

    const data = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, "application/xml");

    const folderNodes = xmlDoc.getElementsByTagName("Prefix");
    const folders = Array.from(folderNodes).map((node) =>
      node.textContent
        ? node.textContent.replace(`${prefixString}/`, "").replace("/", "")
        : "",
    );

    return folders;
  } catch (error) {
    console.error("Error listing folders:", error);
    return [];
  }
};

// get all the images in a folder
export const getImagesInFolder = async (year: string, folderName: string) => {
  const url = `https://${bucketNamePrefix}.s3.amazonaws.com/?list-type=2&prefix=${year}/${folderName}/&delimiter=/`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to fetch images list");
    }

    const data = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, "application/xml");

    const imageNodes = xmlDoc.getElementsByTagName("Key");
    const images = Array.from(imageNodes).map((node) => node.textContent);
    const imageUrls = images.map(
      (image) => `https://${bucketNamePrefix}.s3.amazonaws.com/${image}`,
    );
    return imageUrls;
  } catch (error) {
    console.error("Error listing images:", error);
    return [];
  }
};

async function getSignedUrl(s3Client: any, command: GetObjectCommand) {
  try {
    const signedUrl = await getSignedUrlFromS3(s3Client, command, {
      expiresIn: 3600,
    });
    return signedUrl;
  } catch (error) {
    console.error("Error generating signed URL:", error);
    throw new Error("Could not generate signed URL");
  }
}
